export { default } from './pagination';
export type { PaginationPropTypes } from './types';
